// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.okta-sign-in.auth-container {
  width: auto;
}

.okta-form-title.o-form-head {
  margin-bottom: 40px;
  font-size: 14px;
  font-weight: 300;
  font-family: proxima-nova, sans-serif;
}

.o-form-content {
  margin-bottom: 20px;
}

.o-form-input input[type='text'],
.o-form-input input[type='password'] {
  margin-bottom: 10px;
  border: 1px solid gray;
  text-align: left;
  width: 100%;
  padding: 6px 8px;
}

.o-form-input input[type='text']:focus,
.o-form-input input[type='password']:focus {
  border: 1px solid #00739b;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  outline: 0;
}

#input7 + label {
  font-weight: 700;
  font-size: 14px;
  font-family: proxima-nova, sans-serif;
}
.button-primary {
  color: #fff !important;
  background-color: #00739d;
  border: 1px solid #0e789f !important;
  padding: 6px 12px;
  width: 104.5%;
}
#o-form-input-name-username {
  margin-bottom: 12px;
}
.email-button {
  text-decoration: none;
}
.email-button:hover {
  text-decoration: underline;
}
.button-primary:hover {
  background-color: #0e79a0;
}

.auth-footer {
  margin-top: 10px;
  text-align: left;
  display: grid;
}

/* hide help link */
.js-help {
  display: none;
}
/* hide marker for links */

/* hide default password reset link */
.js-forgot-password {
  display: none;
}
/* hide default password reset link */
ul {
  list-style-type: none;
}
.okta-form-infobox-error {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
  padding: 6px 8px 6px 8px;
  font-size: 16px;
  width: 100%;
  text-align: left;
  font-weight: 400;
  margin-bottom: 10px;
}
.custom-checkbox {
  text-align: left;
}
.custom-checkbox label {
  margin-left: 8px;
}
.custom-checkbox input {
  position: relative;
  top: 1px;
}
.okta-form-label {
  text-align: left;
  font-weight: 700;
  font-family: proxima-nova, sans-serif;
  font-size: 14px;
  margin-bottom: 8px;
}
.okta-form-input-error {
  text-align: left;
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
  padding: 16px 8px;
  width: 100%;
}
.link {
  font-size: 12px;
}
.mfa-send-email-content {
  font-size: 12px;
}
.mask-email {
  display: block;
}
.resend-email-btn {
  display: block;
}
.off-screen {
  font-size: 12px;
}
.o-form-input-name-countryCode {
  display: none;
}
.js-enroll-phone {
  text-decoration: none;
}
.enroll-sms-phone {
  margin-bottom: 20px;
}
input[name='phoneNumber'] {
  margin-left: 8px;
}

.accessibility-text {
  display: none;
}
.enter-auth-code-instead-link {
  padding: 8px;
  margin: 6px;
  color: white;
}
.identifier.no-translate {
  margin-bottom: 8px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/features/login/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA,0BAA0B;;AAE1B,qCAAqC;AACrC;EACE,aAAa;AACf;AACA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".okta-sign-in.auth-container {\n  width: auto;\n}\n\n.okta-form-title.o-form-head {\n  margin-bottom: 40px;\n  font-size: 14px;\n  font-weight: 300;\n  font-family: proxima-nova, sans-serif;\n}\n\n.o-form-content {\n  margin-bottom: 20px;\n}\n\n.o-form-input input[type='text'],\n.o-form-input input[type='password'] {\n  margin-bottom: 10px;\n  border: 1px solid gray;\n  text-align: left;\n  width: 100%;\n  padding: 6px 8px;\n}\n\n.o-form-input input[type='text']:focus,\n.o-form-input input[type='password']:focus {\n  border: 1px solid #00739b;\n  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);\n  outline: 0;\n}\n\n#input7 + label {\n  font-weight: 700;\n  font-size: 14px;\n  font-family: proxima-nova, sans-serif;\n}\n.button-primary {\n  color: #fff !important;\n  background-color: #00739d;\n  border: 1px solid #0e789f !important;\n  padding: 6px 12px;\n  width: 104.5%;\n}\n#o-form-input-name-username {\n  margin-bottom: 12px;\n}\n.email-button {\n  text-decoration: none;\n}\n.email-button:hover {\n  text-decoration: underline;\n}\n.button-primary:hover {\n  background-color: #0e79a0;\n}\n\n.auth-footer {\n  margin-top: 10px;\n  text-align: left;\n  display: grid;\n}\n\n/* hide help link */\n.js-help {\n  display: none;\n}\n/* hide marker for links */\n\n/* hide default password reset link */\n.js-forgot-password {\n  display: none;\n}\n/* hide default password reset link */\nul {\n  list-style-type: none;\n}\n.okta-form-infobox-error {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #a94442;\n  padding: 6px 8px 6px 8px;\n  font-size: 16px;\n  width: 100%;\n  text-align: left;\n  font-weight: 400;\n  margin-bottom: 10px;\n}\n.custom-checkbox {\n  text-align: left;\n}\n.custom-checkbox label {\n  margin-left: 8px;\n}\n.custom-checkbox input {\n  position: relative;\n  top: 1px;\n}\n.okta-form-label {\n  text-align: left;\n  font-weight: 700;\n  font-family: proxima-nova, sans-serif;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n.okta-form-input-error {\n  text-align: left;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #a94442;\n  padding: 16px 8px;\n  width: 100%;\n}\n.link {\n  font-size: 12px;\n}\n.mfa-send-email-content {\n  font-size: 12px;\n}\n.mask-email {\n  display: block;\n}\n.resend-email-btn {\n  display: block;\n}\n.off-screen {\n  font-size: 12px;\n}\n.o-form-input-name-countryCode {\n  display: none;\n}\n.js-enroll-phone {\n  text-decoration: none;\n}\n.enroll-sms-phone {\n  margin-bottom: 20px;\n}\ninput[name='phoneNumber'] {\n  margin-left: 8px;\n}\n\n.accessibility-text {\n  display: none;\n}\n.enter-auth-code-instead-link {\n  padding: 8px;\n  margin: 6px;\n  color: white;\n}\n.identifier.no-translate {\n  margin-bottom: 8px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
